import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { withStyles } from 'tss-react/mui';
import PropTypes from 'prop-types';
import React from 'react';

const styles = () => ({
  dialogContentWithNewLines: {
    whiteSpace: 'pre-wrap',
    color: 'black',
  },
});

function ActionDialog(props) {
  const {
    dialogTitle,
    contentText,
    contentFields,
    actions,
    handleClose,
    open,
    fullWidth,
    maxWidth,
    classes,
  } = props;

  return (
    <Dialog
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      open={open}
      onClose={(e, reason) => {
        handleClose(e, reason);
      }}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">{dialogTitle}</DialogTitle>
      <DialogContent style={{ overflow: 'hidden' }}>
        <DialogContentText className={classes.dialogContentWithNewLines}>
          {contentText}
        </DialogContentText>
        {contentFields}
      </DialogContent>
      <DialogActions>{actions}</DialogActions>
    </Dialog>
  );
}

ActionDialog.propTypes = {
  dialogTitle: PropTypes.string.isRequired,
  contentText: PropTypes.string.isRequired,
  contentFields: PropTypes.object,
  actions: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
  maxWidth: PropTypes.string,
};

export default withStyles(ActionDialog, styles);
